import { render, staticRenderFns } from "./PrintingLayout.vue?vue&type=template&id=c7166bec&scoped=true"
import script from "./PrintingLayout.vue?vue&type=script&lang=js"
export * from "./PrintingLayout.vue?vue&type=script&lang=js"
import style0 from "./PrintingLayout.vue?vue&type=style&index=0&id=c7166bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7166bec",
  null
  
)

export default component.exports